import React from 'react';
import ModalBody from './ModalBody';
import store from 'root/store'
import { Provider } from 'react-redux'

class ModalProvider extends React.Component {

  constructor(props){
    super(props);
  }

  render() {
    const { children, ...otherProps } = this.props;

		return (
      <Provider store={store}>
        <ModalBody {...this.props} />
      </Provider>
    );
  }
}

export default ModalProvider;



// WEBPACK FOOTER //
// ./src/template/Modals/Attendance/ModalProvider.js